import { render, staticRenderFns } from "./form_detail.vue?vue&type=template&id=1cd35a84&scoped=true&"
import script from "./form_detail.vue?vue&type=script&lang=js&"
export * from "./form_detail.vue?vue&type=script&lang=js&"
import style0 from "./form_detail.vue?vue&type=style&index=0&id=1cd35a84&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd35a84",
  null
  
)

export default component.exports